import { sessionAuthenticationSteps } from '../constants/sessionAuthenticationSteps';

export const handleRegistrationButtonClick = (step, modal) => {
  step(sessionAuthenticationSteps.email);
  modal({ renderType: 'AUTH', isOpen: true });
};
